import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledNotVaccinatedSyringeIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 41 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: .0214844,
			width: 40,
			height: 40,
			rx: 12,
			fill: "#F8F6F5"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_28359_6041)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M22.0215 30L30.0215 22",
					stroke: "#636366",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.7286 17.7071L24.0215 28L28.0215 24L17.7286 13.7071C17.3381 13.3166 16.7049 13.3166 16.3144 13.7071L13.7286 16.2929C13.3381 16.6834 13.3381 17.3166 13.7286 17.7071Z",
					fill: "white",
					stroke: "#636366",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.5215 24.5L22.5215 22.5",
					stroke: "#636366",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M18.5215 22.5L20.5215 20.5",
					stroke: "#636366",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.5215 20.5L18.5215 18.5",
					stroke: "#636366",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.0215 14L14.0215 16L16.0215 14L14.0215 12L12.0215 14Z",
					fill: "white",
					stroke: "#636366",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.02148 9L13.0215 13",
					stroke: "#636366",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.0215 30L25.0215 27L27.0215 25L30.0215 28L28.0215 30Z",
					fill: "#C0C0C0",
					stroke: "#636366",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27.0215 31L31.0215 27",
					stroke: "#636366",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_28359_6041",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white",
				transform: "translate(8.02148 8)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgFilledNotVaccinatedSyringeIcon);
const Memo = memo(ForwardRef);
export default Memo;
